import { Typography } from "@mui/material";
import NotFoundImage from "assets/admin/notfound.png";
import { Button } from "components/LoadingButton";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "react-router-dom";
import useStore from "store";
import classes from "./style.module.scss";

const NotFound = () => {
  const { accessTokenStore } = useStore();

  return (
    <div className={classes.container}>
      <LazyLoadImage className={classes.notFoundImage} src={NotFoundImage} />
      <div className={classes.actionBox}>
        <Typography variant="h4">صفحه مورد نظر پیدا نشد</Typography>
        <Link to={accessTokenStore ? "/dashboard" : "/login"}>
          <Button>صفحه اصلی</Button>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
